<ng-container *ngIf="orientation === 'horizontal'">
  <div
    class="form-row align-items-center"
    [ngStyle]="templateForPermitForm ? {
      display: 'flex',
      flexDirection: 'row',
      columnGap: '15px',
    } : {
      justifyContent: 'space-between'
    }"
  
  >
    <div
      class="col-auto my-1"
      style="flex: auto"
      *ngFor="let entity of entities"
    >
      <wm-data-entity-input
        *ngIf="
          !isPreview &&
          entity.entity &&
          entity.type == 'default-data-entity-layout'
        "
        [entity]="entity.entity"
        [form]="form"
        [applicationId]="applicationId"
        [activity]="activity"
        [orientation]="'horizontal'"
        #dataEntityInput
      ></wm-data-entity-input>
      <wm-data-entity-group-layout-input
        *ngIf="entity.type === 'group-data-entity-layout'"
        [layoutModel]="entity"
        [form]="form"
        [isReadOnly]="false"
        [applicationId]="applicationId"
        [orientation]="'horizontal'"
        [activity]="activity"
        #dataEntityGroupLayoutInput
      >
      </wm-data-entity-group-layout-input>
      <wm-data-entity-table-layout-input
        *ngIf="entity.type === 'table-data-entity-layout'"
        [layoutModel]="entity"
        [form]="form"
        [applicationId]="applicationId"
        [isReadOnly]="false"
        [orientation]="'horizontal'"
        [activity]="activity"
        #dataEntityTableLayoutInput
      >
      </wm-data-entity-table-layout-input>
      <wm-data-entity-row-layout-input
        *ngIf="entity.type === 'row-data-entity-layout'"
        [layoutModel]="entity"
        [form]="form"
        [applicationId]="applicationId"
        [isReadOnly]="false"
        [orientation]="'horizontal'"
        [activity]="activity"
        #dataEntityRowLayoutInput
      >
      </wm-data-entity-row-layout-input>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="orientation === 'vertical'">
  <div *ngFor="let de of entities">
    <!-- Render different layout components based on the type of data entity layout -->
    <wm-data-entity-group-layout-input
      *ngIf="de.type === 'group-data-entity-layout'"
      [layoutModel]="de"
      [form]="form"
      [isReadOnly]="false"
      [applicationId]="applicationId"
      [orientation]="orientation"
      [activity]="activity"
      #dataEntityGroupLayoutInput
    >
    </wm-data-entity-group-layout-input>
    <wm-data-entity-table-layout-input
      *ngIf="de.type === 'table-data-entity-layout'"
      [layoutModel]="de"
      [form]="form"
      [applicationId]="applicationId"
      [isReadOnly]="false"
      [orientation]="orientation"
      [activity]="activity"
      #dataEntityTableLayoutInput
    >
    </wm-data-entity-table-layout-input>
    <wm-data-entity-row-layout-input
      *ngIf="de.type === 'row-data-entity-layout'"
      [layoutModel]="de"
      [form]="form"
      [applicationId]="applicationId"
      [isReadOnly]="false"
      [orientation]="orientation"
      [activity]="activity"
      #dataEntityRowLayoutInput
    >
    </wm-data-entity-row-layout-input>
    <wm-data-entity-input
      *ngIf="!isPreview && de.entity && de.type == 'default-data-entity-layout'"
      [entity]="de.entity"
      [form]="form"
      [applicationId]="applicationId"
      [activity]="activity"
      [orientation]="orientation"
      #dataEntityInput
    ></wm-data-entity-input>
  </div>
</ng-container>

<!-- <div *ngFor="let de of entities">
  <div class="form-group">
    <wm-data-entity-group-layout
      *ngIf="de.type === 'group-data-entity-layout'"
      [layoutModel]="de"
      [form]="form"
      [isReadOnly]="false"
      [applicationId]="applicationId"
      [orientation]="orientation"
      [activity]="activity">
    </wm-data-entity-group-layout>
    <wm-data-entity-table-layout
      *ngIf="de.type === 'table-data-entity-layout'"
      [layoutModel]="de"
      [form]="form"
      [applicationId]="applicationId"
      [isReadOnly]="false"
      [orientation]="orientation"
      [activity]="activity">
    </wm-data-entity-table-layout>
    <wm-data-entity-row-layout
      *ngIf="de.type === 'row-data-entity-layout'"
      [layoutModel]="de"
      [form]="form"
      [applicationId]="applicationId"
      [isReadOnly]="false"
      [orientation]="orientation"
      [activity]="activity">
    </wm-data-entity-row-layout>
    <wm-data-entity-input
      *ngIf="!isPreview && de.entity && de.type == 'default-data-entity-layout'"
      [entity]="de.entity"
      [form]="form"
      [applicationId]="applicationId"
      [activity]="activity"
      [orientation]="orientation"
      #dataEntityInput
    ></wm-data-entity-input>
  </div>
</div> -->
